import { useState } from "react"
import { RoomSchedule } from "@/components/schedule/room-schedule"
import type { Booking, Room } from "@/types/schedule"

// ─── Mock data (tạm — chưa nối API) ──────────────────────────────
const ROOM_TYPES = ["Tiêu chuẩn", "VIP", "SuperVip"] as const

function todayInput(): string {
    return new Date().toISOString().slice(0, 10)
}

interface BookingSectionProps {
    id?: string
    rooms: Room[]
    bookings: Booking[]
    scheduleDate: Date
    onDateChange: (date: Date) => void
    onBookingCreate: (booking: Omit<Booking, "id">) => void | Promise<void>
    focusedRoomId: string | null
    onFocusChange: (roomId: string | null) => void
}

export function BookingSection({
    id,
    rooms,
    bookings,
    scheduleDate,
    onDateChange,
    onBookingCreate,
    focusedRoomId,
    onFocusChange,
}: BookingSectionProps) {
    const [selectedType, setSelectedType] = useState<string>(ROOM_TYPES[0])
    const [date, setDate] = useState<string>(todayInput)

    return (
        <section id={id} className="scroll-mt-24">
            {/* ── Phần hướng dẫn (#f4eee4) ── */}
            <div className="bg-[#f4eee4] px-4 py-8 sm:px-8">
                <div className="mx-auto max-w-[1080px] space-y-4">
                    {/* Thanh điều khiển */}
                    <div className="flex flex-wrap items-center justify-between gap-4 rounded-xl bg-white px-4 py-3 shadow-sm">
                        <div className="flex flex-wrap items-center gap-4">
                            <button
                                type="button"
                                className="rounded-md bg-[#a8987d] px-4 py-1.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-[#948467]"
                            >
                                Hướng dẫn
                            </button>
                            <label className="flex items-center gap-2 text-sm text-[#6f6555]">
                                <span className="font-medium">Chọn ngày:</span>
                                <input
                                    type="date"
                                    value={date}
                                    onChange={(e) => setDate(e.target.value)}
                                    className="rounded-md border border-[#e0d8c8] bg-white px-2 py-1 text-sm text-[#3d342a] outline-none transition-colors focus:border-[#a8987d]"
                                />
                            </label>
                        </div>

                        <div className="flex items-center gap-1">
                            {ROOM_TYPES.map((type) => (
                                <button
                                    key={type}
                                    type="button"
                                    onClick={() => setSelectedType(type)}
                                    className={`rounded-md px-3 py-1.5 text-sm font-medium transition-colors ${selectedType === type
                                        ? "bg-[#efe7d8] text-[#3d342a]"
                                        : "text-[#8a8175] hover:text-[#3d342a]"
                                        }`}
                                >
                                    {type}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Ô ghi chú / ưu đãi */}
                    <div className="rounded-xl bg-white px-4 py-3 shadow-sm">
                        <p className="text-sm font-bold text-[#3d342a]">
                            Được thêm ảnh (để hiện các ưu đãi hay ghi chú)
                        </p>
                        <p className="mt-1 text-xs text-[#8a8175]">Tiện nghi: bla bla bla</p>
                    </div>
                </div>
            </div>

            {/* ── Phần dưới: lịch (#fffcf7) ── */}
            <div className="bg-[#fffcf7] px-4 py-12 sm:px-8">
                <RoomSchedule
                    date={scheduleDate}
                    rooms={rooms}
                    bookings={bookings}
                    onDateChange={onDateChange}
                    onBookingCreate={onBookingCreate}
                    startHour={0}
                    endHour={24}
                    focusedRoomId={focusedRoomId}
                    onFocusChange={onFocusChange}
                />
            </div>
        </section>
    )
}
